import { slideTransitionsDetails } from '../../reference/transitions';

export const calculateSlideOwnDelayForTransitionOut = ({
  nextSlide: {
    transition: { type, duration },
  },
}) => {
  return slideTransitionsDetails[type].influence.prevSlide * duration;
};
